/* eslint-disable */
import { useState, useEffect } from "react";
import logoImg from './logo.png';

const G = "#58FF88";
const BK = "#000000";
const DG = "#514F4C";
const MG = "#8D8C8A";
const LG = "#E6E6E5";
const LOGO_URL = logoImg;
const EMAILJS_SERVICE_ID  = "errezeta_service";
const EMAILJS_TEMPLATE_ID = "template_ocxx6vu";
const EMAILJS_PUBLIC_KEY  = "Jpn0h-PYttkke6OTs";
const RECIPIENT_EMAIL     = "ricardo@erre-zeta.com";

const DEBILIDADES_NEW = ["Sin experiencia en marketing","Presupuesto limitado","Sin equipo definido","Producto/servicio no validado","Sin red de contactos","Sin presencia digital","Competencia muy consolidada","Falta de capital"];
const DEBILIDADES_EST = ["Imagen de marca desactualizada","Baja presencia digital","Falta de consistencia","Poca diferenciación vs competencia","Falta de claridad estratégica","Problemas de reputación","Falta de fidelización","Procesos internos caóticos","Acciones de marketing reactivas","Falta de planificación"];
const CANALES   = ["Instagram","TikTok","Facebook","LinkedIn","Email marketing","Sitio web / SEO","WhatsApp / Mensajería","Publicidad pagada","Boca a boca / Referidos","Eventos / Ferias"];
const OBJETIVOS = ["Crear marca desde cero","Rediseñar / refrescar identidad","Lanzar nuevo producto/servicio","Crecer en redes sociales","Generar más ventas","Mejorar posicionamiento","Expansión a nuevos mercados","Estrategia de marca","Diagnóstico profundo de marca / empresa","Incrementar participación del mercado"];
const STEPS_NUEVO = ["intro","tipo","datos_basicos","industria","idea","cliente_ideal","competencia","fortalezas_nuevo","debilidades_nuevo","oportunidades","amenazas","presupuesto","canales","objetivos","extra","preresumen"];
const STEPS_EST   = ["intro","tipo","datos_basicos_est","industria","marca_actual","cliente_actual","competencia","fortalezas_est","debilidades_est","oportunidades","amenazas","presupuesto","canales","objetivos","extra","preresumen"];

const s = {
  wrap: { background: BK, minHeight: "100vh", fontFamily: "'Segoe UI', Arial, sans-serif", color: "#fff", display: "flex", flexDirection: "column", alignItems: "center" },
  header: { width: "100%", background: BK, borderBottom: "1px solid #1a1a1a", padding: "16px 32px", display: "flex", alignItems: "center", boxSizing: "border-box" },
  progress: { height: 3, background: "#111", width: "100%", position: "sticky", top: 0, zIndex: 10 },
  progressBar: p => ({ height: "100%", background: G, width: `${p}%`, transition: "width 0.5s ease" }),
  main: { width: "100%", maxWidth: 680, padding: "40px 24px 80px", boxSizing: "border-box" },
  sectionLabel: { fontSize: 11, fontWeight: 700, letterSpacing: 3, color: G, textTransform: "uppercase", marginBottom: 8 },
  question: { fontSize: 22, fontWeight: 700, color: "#fff", lineHeight: 1.35, marginBottom: 10 },
  subtext: { fontSize: 14, color: MG, marginBottom: 28, lineHeight: 1.6 },
  optionGrid: { display: "grid", gap: 12 },
  option: sel => ({ border: `2px solid ${sel ? G : "#2a2a2a"}`, background: sel ? `${G}18` : "#111", color: sel ? G : "#ccc", borderRadius: 10, padding: "16px 20px", cursor: "pointer", fontSize: 15, fontWeight: sel ? 700 : 400, transition: "all 0.2s", textAlign: "left", display: "flex", gap: 12, alignItems: "flex-start" }),
  optionIcon: { fontSize: 20, marginTop: 1, flexShrink: 0 },
  optionText: { flex: 1 },
  optionTitle: { fontWeight: 700, marginBottom: 2 },
  optionDesc: sel => ({ fontSize: 12, color: sel ? `${G}bb` : "#555", lineHeight: 1.4 }),
  textarea: { width: "100%", background: "#111", border: "2px solid #2a2a2a", borderRadius: 10, padding: "14px 16px", color: "#fff", fontSize: 15, resize: "vertical", minHeight: 100, boxSizing: "border-box", outline: "none", fontFamily: "inherit", lineHeight: 1.6 },
  input: { width: "100%", background: "#111", border: "2px solid #2a2a2a", borderRadius: 10, padding: "14px 16px", color: "#fff", fontSize: 15, boxSizing: "border-box", outline: "none", fontFamily: "inherit" },
  checkGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 },
  check: sel => ({ border: `2px solid ${sel ? G : "#2a2a2a"}`, background: sel ? `${G}18` : "#111", color: sel ? G : "#aaa", borderRadius: 8, padding: "12px 14px", cursor: "pointer", fontSize: 14, fontWeight: sel ? 700 : 400, transition: "all 0.2s" }),
  nav: { display: "flex", gap: 12, marginTop: 40, justifyContent: "space-between", alignItems: "center" },
  btnPrimary: { background: G, color: BK, border: "none", borderRadius: 8, padding: "14px 32px", fontSize: 15, fontWeight: 800, cursor: "pointer", letterSpacing: 1 },
  btnSecondary: { background: "transparent", color: MG, border: "2px solid #2a2a2a", borderRadius: 8, padding: "14px 24px", fontSize: 14, cursor: "pointer" },
  btnGhost: { background: "transparent", color: G, border: `2px solid ${G}`, borderRadius: 8, padding: "12px 24px", fontSize: 14, fontWeight: 700, cursor: "pointer" },
  stepCount: { fontSize: 13, color: DG },
  scaleWrap: { display: "flex", gap: 8, flexWrap: "wrap" },
  scaleBtn: sel => ({ width: 44, height: 44, borderRadius: 8, border: `2px solid ${sel ? G : "#2a2a2a"}`, background: sel ? `${G}22` : "#111", color: sel ? G : "#666", fontWeight: sel ? 800 : 400, fontSize: 15, cursor: "pointer", transition: "all 0.15s" }),
  scaleLabels: { display: "flex", justifyContent: "space-between", fontSize: 11, color: "#444", marginTop: 6 },
};

function ErreZetaLogo({ width = 220 }) {
  return (
    <img
      src={LOGO_URL}
      alt="ERRE ZETA"
      style={{ width, maxWidth: "85vw", objectFit: "contain" }}
    />
  );
}

export default function App() {
  const [step, setStep]   = useState(0);
  const [tipo, setTipo]   = useState(null);
  const [data, setData]   = useState({});
  const [done, setDone]   = useState(false);

  const set    = (k, v) => setData(d => ({ ...d, [k]: v }));
  const toggle = (k, v) => setData(d => { const a = d[k] || []; return { ...d, [k]: a.includes(v) ? a.filter(x => x !== v) : [...a, v] }; });

  const steps    = tipo === "nuevo" ? STEPS_NUEVO : tipo === "establecido" ? STEPS_EST : ["intro","tipo"];
  const total    = steps.length;
  const id       = steps[step];
  const progress = Math.round((step / (total - 1)) * 100);

  const canNext = () => {
    if (id === "intro") return true;
    if (id === "tipo") return !!tipo;
    if (id === "datos_basicos" || id === "datos_basicos_est") return !!data.nombre_negocio;
    if (id === "industria") return !!data.industria;
    return true;
  };

  const goNext = () => { if (step === total - 1) { setDone(true); return; } setStep(s => s + 1); };
  const goBack = () => step > 0 && setStep(s => s - 1);

  if (done) return <Resumen data={data} tipo={tipo} onRestart={() => { setDone(false); setStep(0); setTipo(null); setData({}); }} />;

  return (
    <div style={s.wrap}>
      {id !== "intro" && (
        <>
          <div style={s.header}>
            <ErreZetaLogo width={110} />
            <div style={{ flex: 1 }} />
            <div style={s.stepCount}>{step > 1 ? `${step - 1} / ${total - 3}` : ""}</div>
          </div>
          <div style={s.progress}><div style={s.progressBar(progress)} /></div>
        </>
      )}
      {id === "intro"
        ? <Intro onStart={() => setStep(1)} />
        : (
          <div style={s.main}>
            <StepRouter id={id} tipo={tipo} setTipo={setTipo} data={data} set={set} toggle={toggle} />
            <div style={s.nav}>
              {step > 1 ? <button style={s.btnSecondary} onClick={goBack}>← Atrás</button> : <div />}
              <button style={{ ...s.btnPrimary, opacity: canNext() ? 1 : 0.3, cursor: canNext() ? "pointer" : "default" }} onClick={canNext() ? goNext : undefined}>
                {step === total - 1 ? "✓ Enviar" : "Continuar →"}
              </button>
            </div>
          </div>
        )}
    </div>
  );
}

// ─── INTRO ───────────────────────────────────────────────────────────────────
function Intro({ onStart }) {
  return (
    <div style={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: BK, padding: "40px 24px", boxSizing: "border-box" }}>
      <ErreZetaLogo width={260} />
      <div style={{ width: 48, height: 3, background: G, margin: "36px 0 32px", borderRadius: 2 }} />
      <h1 style={{ fontFamily: "Arial Black, Arial, sans-serif", fontWeight: 900, fontSize: "clamp(26px,5vw,40px)", color: "#fff", textAlign: "center", margin: "0 0 16px", lineHeight: 1.15, maxWidth: 560 }}>
        Antes de crear, necesitamos <span style={{ color: G }}>conocerte.</span>
      </h1>
      <p style={{ fontSize: 16, color: MG, textAlign: "center", maxWidth: 480, lineHeight: 1.75, margin: "0 0 48px" }}>
        Este cuestionario nos ayuda a entender tu marca, tu negocio y el entorno en el que operas. Con esa base, construimos estrategias que realmente funcionan.
      </p>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center", marginBottom: 52 }}>
        {[["⏱","5–8 minutos"],["🔒","100% confidencial"],["🎯","Totalmente personalizado"]].map(([icon, label]) => (
          <div key={label} style={{ background: "#111", border: "1px solid #222", borderRadius: 10, padding: "14px 20px", display: "flex", alignItems: "center", gap: 10, fontSize: 14, color: LG }}>
            <span style={{ fontSize: 20 }}>{icon}</span>{label}
          </div>
        ))}
      </div>
      <button onClick={onStart} style={{ background: G, color: BK, border: "none", borderRadius: 10, padding: "18px 52px", fontSize: 17, fontWeight: 900, cursor: "pointer", letterSpacing: 1.5, textTransform: "uppercase", boxShadow: `0 0 32px ${G}44` }}>
        Comenzar →
      </button>
      <p style={{ fontSize: 12, color: DG, marginTop: 20 }}>Tu información nunca será compartida con terceros.</p>
    </div>
  );
}

// ─── STEP ROUTER ─────────────────────────────────────────────────────────────
function StepRouter({ id, tipo, setTipo, data, set, toggle }) {
  switch (id) {
    case "tipo":              return <StepTipo tipo={tipo} setTipo={setTipo} />;
    case "datos_basicos":     return <StepDatosBasicos data={data} set={set} />;
    case "datos_basicos_est": return <StepDatosBasicosEst data={data} set={set} />;
    case "industria":         return <StepIndustria data={data} set={set} />;
    case "idea":              return <StepIdea data={data} set={set} />;
    case "marca_actual":      return <StepMarcaActual data={data} set={set} />;
    case "cliente_ideal":     return <StepClienteIdeal data={data} set={set} />;
    case "cliente_actual":    return <StepClienteActual data={data} set={set} />;
    case "competencia":       return <StepCompetencia data={data} set={set} />;
    case "fortalezas_nuevo":  return <StepFortalezas data={data} set={set} tipo="nuevo" />;
    case "fortalezas_est":    return <StepFortalezas data={data} set={set} tipo="est" />;
    case "debilidades_nuevo": return <StepDebilidades data={data} toggle={toggle} tipo="nuevo" />;
    case "debilidades_est":   return <StepDebilidades data={data} toggle={toggle} tipo="establecido" />;
    case "oportunidades":     return <StepOportunidades data={data} set={set} />;
    case "amenazas":          return <StepAmenazas data={data} set={set} />;
    case "presupuesto":       return <StepPresupuesto data={data} set={set} />;
    case "canales":           return <StepCanales data={data} toggle={toggle} />;
    case "objetivos":         return <StepObjetivos data={data} toggle={toggle} />;
    case "extra":             return <StepExtra data={data} set={set} />;
    case "preresumen":        return <StepPreResumen />;
    default:                  return null;
  }
}

// ─── ALL STEPS ───────────────────────────────────────────────────────────────
function StepTipo({ tipo, setTipo }) {
  return (
    <div>
      <div style={s.sectionLabel}>Bienvenid@</div>
      <div style={s.question}>¿Cómo describirías tu situación actual?</div>
      <div style={s.subtext}>Esta respuesta personaliza el resto del cuestionario para ti.</div>
      <div style={s.optionGrid}>
        {[{val:"nuevo",icon:"🚀",title:"Tengo un nuevo emprendimiento",desc:"Estoy comenzando — mi marca o negocio está en etapa inicial o de idea."},
          {val:"establecido",icon:"🏢",title:"Tengo un negocio en marcha",desc:"Mi empresa ya opera, genera ventas y quiero crecer o mejorar."}].map(o => (
          <button key={o.val} style={s.option(tipo===o.val)} onClick={() => setTipo(o.val)}>
            <span style={s.optionIcon}>{o.icon}</span>
            <span style={s.optionText}><div style={s.optionTitle}>{o.title}</div><div style={s.optionDesc(tipo===o.val)}>{o.desc}</div></span>
          </button>
        ))}
      </div>
    </div>
  );
}

function StepDatosBasicos({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Cuéntanos sobre ti</div>
      <div style={s.question}>¿Cómo se llama tu emprendimiento y cómo te llamas tú?</div>
      <div style={s.subtext}>Si aún no tiene nombre, escribe el que tienes en mente o simplemente "sin nombre".</div>
      <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
        <input style={s.input} placeholder="Nombre del emprendimiento *" value={data.nombre_negocio||""} onChange={e=>set("nombre_negocio",e.target.value)}/>
        <input style={s.input} placeholder="Tu nombre" value={data.nombre_contacto||""} onChange={e=>set("nombre_contacto",e.target.value)}/>
        <input style={s.input} placeholder="Tu correo electrónico" value={data.email||""} onChange={e=>set("email",e.target.value)}/>
      </div>
    </div>
  );
}

function StepDatosBasicosEst({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Tu empresa</div>
      <div style={s.question}>Datos básicos del negocio</div>
      <div style={s.subtext}>Queremos entender con quién estamos hablando y el tamaño del proyecto.</div>
      <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
        <input style={s.input} placeholder="Nombre del negocio / empresa *" value={data.nombre_negocio||""} onChange={e=>set("nombre_negocio",e.target.value)}/>
        <input style={s.input} placeholder="Tu nombre y cargo" value={data.nombre_contacto||""} onChange={e=>set("nombre_contacto",e.target.value)}/>
        <input style={s.input} placeholder="Tu correo electrónico" value={data.email||""} onChange={e=>set("email",e.target.value)}/>
        <input style={s.input} placeholder="¿Cuántos años lleva operando?" value={data.anos_operando||""} onChange={e=>set("anos_operando",e.target.value)}/>
        <div>
          <div style={{ fontSize:13, color:MG, marginBottom:8 }}>Tamaño del equipo</div>
          <div style={s.checkGrid}>
            {["1–5 personas","6–20 personas","21–50 personas","50+ personas"].map(t=>(
              <button key={t} style={{...s.option(data.tamano===t),padding:"12px 16px"}} onClick={()=>set("tamano",t)}><span style={s.optionText}>{t}</span></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function StepIndustria({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Industria</div>
      <div style={s.question}>¿En qué sector opera tu negocio?</div>
      <div style={s.subtext}>Selecciona la que mejor te represente.</div>
      <div style={s.checkGrid}>
        {["Moda / Retail","Gastronomía / F&B","Tecnología","Servicios profesionales","Salud / Wellness","Educación","Construcción / Inmobiliaria","Entretenimiento / Medios","E-commerce","Servicios B2B","Belleza / Cosméticos","Otro"].map(ind=>(
          <button key={ind} style={s.check(data.industria===ind)} onClick={()=>set("industria",ind)}>{ind}</button>
        ))}
      </div>
      {data.industria==="Otro" && <input style={{...s.input,marginTop:12}} placeholder="Especifica tu industria" value={data.industria_otro||""} onChange={e=>set("industria_otro",e.target.value)}/>}
    </div>
  );
}

function StepIdea({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Tu propuesta de valor</div>
      <div style={s.question}>Cuéntanos qué hace tu emprendimiento</div>
      <div style={s.subtext}>Con tus propias palabras. No necesitas ser formal.</div>
      <textarea style={s.textarea} rows={4} placeholder="Ej: Vendo ropa sostenible para mujeres jóvenes..." value={data.descripcion||""} onChange={e=>set("descripcion",e.target.value)}/>
      <div style={{marginTop:20}}>
        <div style={{fontSize:14,color:MG,marginBottom:12}}>¿En qué etapa está tu emprendimiento?</div>
        <div style={s.optionGrid}>
          {[{val:"idea",label:"💡 Solo es una idea",desc:"Aún no he validado ni ejecutado nada."},
            {val:"validando",label:"🧪 Validando",desc:"Estoy probando con primeros clientes o prototipos."},
            {val:"lanzando",label:"🚀 Listo para lanzar",desc:"Tengo el producto/servicio listo, necesito visibilidad."},
            {val:"creciendo",label:"📈 Operando y creciendo",desc:"Ya tengo clientes y quiero escalar."}].map(o=>(
            <button key={o.val} style={{...s.option(data.etapa===o.val),padding:"12px 16px"}} onClick={()=>set("etapa",o.val)}>
              <span style={s.optionText}><div style={{fontWeight:700}}>{o.label}</div><div style={s.optionDesc(data.etapa===o.val)}>{o.desc}</div></span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function StepMarcaActual({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Tu marca hoy</div>
      <div style={s.question}>¿Cómo describirías el estado actual de tu marca?</div>
      <div style={s.subtext}>Sé honesto — esta información es confidencial.</div>
      <textarea style={s.textarea} placeholder="Ej: Tenemos logo pero nunca fuimos consistentes en comunicación..." value={data.marca_actual||""} onChange={e=>set("marca_actual",e.target.value)}/>
      <div style={{marginTop:20}}>
        <div style={{fontSize:14,color:MG,marginBottom:8}}>Del 1 al 5, ¿qué tan satisfecho estás con tu marca actual?</div>
        <div style={s.scaleWrap}>{[1,2,3,4,5].map(n=><button key={n} style={s.scaleBtn(data.satisfaccion_marca===n)} onClick={()=>set("satisfaccion_marca",n)}>{n}</button>)}</div>
        <div style={s.scaleLabels}><span>Nada satisfecho</span><span>Muy satisfecho</span></div>
      </div>
    </div>
  );
}

function StepClienteIdeal({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Tu cliente</div>
      <div style={s.question}>Describe a tu cliente ideal</div>
      <div style={s.subtext}>¿Quién es, qué hace, qué le importa?</div>
      <textarea style={s.textarea} placeholder="Ej: Mujeres de 25–35 años, profesionales, que les gusta la moda..." value={data.cliente_ideal||""} onChange={e=>set("cliente_ideal",e.target.value)}/>
    </div>
  );
}

function StepClienteActual({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Tu cliente</div>
      <div style={s.question}>¿A quién le vendes actualmente?</div>
      <div style={s.subtext}>¿Hay algún segmento al que quieras llegar y aún no lo haces?</div>
      <textarea style={s.textarea} placeholder="Ej: Nuestros clientes actuales son empresas medianas del sector retail..." value={data.cliente_actual||""} onChange={e=>set("cliente_actual",e.target.value)}/>
    </div>
  );
}

function StepCompetencia({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Competencia</div>
      <div style={s.question}>¿Quiénes son tus principales competidores?</div>
      <div style={s.subtext}>Nombra 2 o 3 marcas similares. ¿Qué hacen bien ellos que tú aún no haces?</div>
      <textarea style={s.textarea} placeholder="Ej: Competidor A tiene mejor precio, Competidor B tiene más seguidores..." value={data.competencia||""} onChange={e=>set("competencia",e.target.value)}/>
      <div style={{marginTop:20}}>
        <div style={{fontSize:14,color:MG,marginBottom:8}}>¿Qué te diferencia de ellos?</div>
        <textarea style={s.textarea} rows={3} placeholder="¿Cuál es tu ventaja competitiva?" value={data.diferenciador||""} onChange={e=>set("diferenciador",e.target.value)}/>
      </div>
    </div>
  );
}

function StepFortalezas({ data, set, tipo }) {
  return (
    <div>
      <div style={s.sectionLabel}>Fortalezas 💪</div>
      <div style={s.question}>{tipo==="nuevo" ? "¿Qué tienes a tu favor?" : "¿Cuáles son los activos más fuertes de tu negocio?"}</div>
      <div style={s.subtext}>{tipo==="nuevo" ? "Experiencia, conocimiento del mercado, red de contactos, capital..." : "Clientes fieles, reputación, equipo, tecnología..."}</div>
      <textarea style={s.textarea} placeholder="Ej: Tengo 10 años de experiencia en la industria..." value={data.fortalezas||""} onChange={e=>set("fortalezas",e.target.value)}/>
    </div>
  );
}

function StepDebilidades({ data, toggle, tipo }) {
  const opciones = tipo==="nuevo" ? DEBILIDADES_NEW : DEBILIDADES_EST;
  const sel = data.debilidades||[];
  return (
    <div>
      <div style={s.sectionLabel}>Puntos de dolor</div>
      <div style={s.question}>¿Cuáles son los puntos de dolor que tienes hoy?</div>
      <div style={s.subtext}>Selecciona todo lo que aplique.</div>
      <div style={s.checkGrid}>{opciones.map(o=><button key={o} style={s.check(sel.includes(o))} onClick={()=>toggle("debilidades",o)}>{o}</button>)}</div>
    </div>
  );
}

function StepOportunidades({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Oportunidades 🌱</div>
      <div style={s.question}>¿Qué oportunidades ves en el mercado que aún no has aprovechado?</div>
      <div style={s.subtext}>Tendencias, cambios en el consumidor, vacíos, nuevos canales.</div>
      <textarea style={s.textarea} placeholder="Ej: El mercado local tiene muy poca competencia online..." value={data.oportunidades||""} onChange={e=>set("oportunidades",e.target.value)}/>
    </div>
  );
}

function StepAmenazas({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Amenazas ⚠️</div>
      <div style={s.question}>¿Qué factores externos podrían afectar tu negocio?</div>
      <div style={s.subtext}>Competencia, cambios regulatorios, economía...</div>
      <textarea style={s.textarea} placeholder="Ej: Entraron 3 competidores nuevos, los costos de publicidad subieron..." value={data.amenazas||""} onChange={e=>set("amenazas",e.target.value)}/>
    </div>
  );
}

function StepPresupuesto({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Inversión</div>
      <div style={s.question}>¿Cuál es tu rango de inversión mensual para marketing y branding?</div>
      <div style={s.subtext}>Información confidencial para diseñar una propuesta realista.</div>
      <div style={s.optionGrid}>
        {["Menos de $500","$500 – $1,500","$1,500 – $3,000","$3,000 – $7,000","Más de $7,000","Aún no lo he definido"].map(p=>(
          <button key={p} style={{...s.option(data.presupuesto===p),padding:"12px 16px"}} onClick={()=>set("presupuesto",p)}><span style={s.optionText}>{p}</span></button>
        ))}
      </div>
    </div>
  );
}

function StepCanales({ data, toggle }) {
  const sel=data.canales||[];
  return (
    <div>
      <div style={s.sectionLabel}>Canales</div>
      <div style={s.question}>¿En qué canales quieres tener presencia?</div>
      <div style={s.subtext}>Selecciona todos los que apliquen.</div>
      <div style={s.checkGrid}>{CANALES.map(c=><button key={c} style={s.check(sel.includes(c))} onClick={()=>toggle("canales",c)}>{c}</button>)}</div>
    </div>
  );
}

function StepObjetivos({ data, toggle }) {
  const sel=data.objetivos||[];
  return (
    <div>
      <div style={s.sectionLabel}>Objetivos</div>
      <div style={s.question}>¿Qué quieres lograr con ERRE ZETA?</div>
      <div style={s.subtext}>Selecciona hasta 3 objetivos principales.</div>
      <div style={s.checkGrid}>{OBJETIVOS.map(o=><button key={o} style={s.check(sel.includes(o))} onClick={()=>toggle("objetivos",o)}>{o}</button>)}</div>
    </div>
  );
}

function StepExtra({ data, set }) {
  return (
    <div>
      <div style={s.sectionLabel}>Última pregunta</div>
      <div style={s.question}>¿Hay algo más que quieras que sepamos?</div>
      <div style={s.subtext}>Referencias, marcas que admiras, colores que te gustan, expectativas...</div>
      <textarea style={s.textarea} rows={5} placeholder="Escribe lo que quieras aquí..." value={data.extra||""} onChange={e=>set("extra",e.target.value)}/>
    </div>
  );
}

function StepPreResumen() {
  return (
    <div style={{textAlign:"center",padding:"40px 0"}}>
      <div style={{fontSize:52,marginBottom:20}}>✨</div>
      <div style={{fontSize:24,fontWeight:800,color:"#fff",marginBottom:12}}>¡Ya casi terminamos!</div>
      <div style={{fontSize:15,color:MG,lineHeight:1.7}}>Presiona <span style={{color:G,fontWeight:700}}>Enviar</span> para que nuestro equipo reciba tu información y prepare una propuesta personalizada.</div>
    </div>
  );
}

// ─── RESUMEN ─────────────────────────────────────────────────────────────────
function Resumen({ data, tipo, onRestart }) {
  const [status, setStatus] = useState("generating"); // generating | done | error
  const [emailStatus, setEmailStatus] = useState("pending"); // pending | sent | error
  const reportRef = useState("")[0];
  const [report, setReport] = useState("");

  const rows = [
    { label:"Tipo de cliente",           val: tipo==="nuevo" ? "Nuevo emprendimiento" : "Negocio establecido" },
    { label:"Nombre del negocio",         val: data.nombre_negocio },
    { label:"Contacto",                   val: [data.nombre_contacto, data.email].filter(Boolean).join(" · ") },
    { label:"Industria",                  val: data.industria },
    tipo==="nuevo"       && { label:"Etapa",            val: data.etapa },
    tipo==="establecido" && { label:"Años operando",    val: data.anos_operando },
    tipo==="establecido" && { label:"Tamaño del equipo",val: data.tamano },
    { label:"Descripción / Marca actual", val: data.descripcion || data.marca_actual },
    { label:"Cliente objetivo",           val: data.cliente_ideal || data.cliente_actual },
    { label:"Competencia",                val: data.competencia },
    { label:"Diferenciador",              val: data.diferenciador },
    { label:"Fortalezas",                 val: data.fortalezas },
    { label:"Áreas de mejora",            val: (data.debilidades||[]).join(", ") },
    { label:"Oportunidades",              val: data.oportunidades },
    { label:"Amenazas",                   val: data.amenazas },
    { label:"Presupuesto mensual",        val: data.presupuesto },
    { label:"Canales de interés",         val: (data.canales||[]).join(", ") },
    { label:"Objetivos con ERRE ZETA",    val: (data.objetivos||[]).join(", ") },
    data.extra && { label:"Información adicional", val: data.extra },
  ].filter(Boolean).filter(r => r.val);

  const buildContext = () => rows.map(r => `${r.label}: ${r.val}`).join("\n");

  // Auto-genera y envía al montar
  useEffect(() => { generateAndSend(); }, []);

  async function loadEmailJS() {
    if (window.emailjs) return;
    await new Promise((res, rej) => {
      const sc = document.createElement("script");
      sc.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
      sc.onload = res; sc.onerror = rej;
      document.head.appendChild(sc);
    });
    window.emailjs.init(EMAILJS_PUBLIC_KEY);
  }

  async function generateAndSend() {
    setStatus("generating");
    try {
      // 1. Generar informe con IA
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 4000,
          tools: [{ type: "web_search_20250305", name: "web_search" }],
          messages: [{
            role: "user",
            content: `Eres un estratega senior de branding y marketing de la agencia ERRE ZETA. 

PASO 1 — Antes de redactar el informe, investiga en internet lo siguiente basándote en la industria y descripción del prospecto:
- Principales competidores locales y regionales en su categoría
- Propuestas de valor y mensajes clave de esos competidores
- Tamaño aproximado del mercado y tendencias actuales de la categoría
- Noticias o movimientos recientes relevantes del sector
- Benchmarks de posicionamiento y precios si están disponibles

PASO 2 — Con las respuestas del cliente Y la investigación de mercado, genera un informe ejecutivo interno en español. Este informe es para el equipo de ERRE ZETA, NO para el cliente.

Estructura el informe así:

**1. FICHA DEL PROSPECTO**
Nombre, tipo, industria, etapa, presupuesto, contacto.

**2. RESUMEN EJECUTIVO**
2-3 párrafos que sinteticen quién es este cliente, qué necesita y qué oportunidad representa para la agencia.

**3. INTELIGENCIA DE MERCADO**
Basado en tu investigación:
- Principales competidores identificados y sus mensajes clave
- Tamaño y tendencias del mercado/categoría
- Oportunidades y amenazas del entorno competitivo real
- Benchmarks relevantes del sector

**4. ANÁLISIS FODA**
Cruza lo que dijo el cliente con lo que encontraste en la investigación:
- Fortalezas (del negocio del cliente)
- Oportunidades (del entorno real del mercado)
- Debilidades (áreas de mejora identificadas)
- Amenazas (competencia real y factores externos)
2-3 puntos concretos por cuadrante.

**5. CLASIFICACIÓN DEL PROSPECTO**
Potencial: Alto / Medio / Bajo
Justificación clara en 2-3 líneas.
Urgencia estimada: inmediata / corto plazo / largo plazo.

**6. CONCLUSIONES**
Contrasta lo que el cliente nos dijo sobre sí mismo con lo que encontramos en la investigación de mercado. ¿Coincide su autopercepción con la realidad del mercado? ¿Dónde hay brechas importantes? Sé directo y crítico.

**7. DIAGNÓSTICO**
De manera específica y muy directa: cuál es el problema real de esta marca/negocio. No uses lenguaje genérico. Nombra los problemas concretos de posicionamiento, comunicación, presencia digital y diferenciación que detectas.

**8. PRÓXIMOS PASOS**
Recomendaciones concretas y accionables para que ERRE ZETA avance con este cliente:
- Qué proponer en la reunión inicial
- Qué servicios específicos ofrecer y en qué orden
- Qué información adicional conseguir del cliente
- Cuál debería ser el primer entregable

Sé directo, crítico y accionable. Evita el lenguaje genérico. Basa todo en los datos reales del cliente y la investigación de mercado.

DATOS DEL PROSPECTO:
${buildContext()}`
          }]
        })
      });
      const json = await res.json();
      const text = json.content
        ?.filter(b => b.type === "text")
        .map(b => b.text)
        .join("\n") || "";
      if (!text) throw new Error("empty");
      setReport(text);
      setStatus("done");

      // 2. Enviar correo con el informe
      if (EMAILJS_SERVICE_ID !== "TU_SERVICE_ID") {
        try {
          await loadEmailJS();
          const fecha = new Date().toLocaleDateString("es-EC", { year:"numeric", month:"long", day:"numeric", hour:"2-digit", minute:"2-digit" });
          await window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
            to_email:       RECIPIENT_EMAIL,
            cliente_nombre: data.nombre_negocio || "Sin nombre",
            cliente_email:  data.email || "No especificado",
            tipo_cliente:   tipo === "nuevo" ? "Nuevo emprendimiento" : "Negocio establecido",
            industria:      data.industria || "—",
            presupuesto:    data.presupuesto || "—",
            fecha,
            respuestas:     buildContext(),
            informe_ia:     text,
          });
          setEmailStatus("sent");
        } catch(e) {
          setEmailStatus("error");
        }
      }
    } catch(e) {
      setStatus("error");
    }
  }

  const printPDF = (reportText) => {
    const fecha = new Date().toLocaleDateString("es-EC", { year:"numeric", month:"long", day:"numeric" });
    const htmlReport = (reportText || report)
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/\n\n/g, "</p><p>")
      .replace(/\n/g, "<br>");

    const win = window.open("", "_blank");
    win.document.write(`<!DOCTYPE html><html><head>
      <meta charset="UTF-8">
      <title>Informe ERRE ZETA — ${data.nombre_negocio||"Cliente"}</title>
      <style>
        * { margin:0; padding:0; box-sizing:border-box; }
        body { font-family: Arial, sans-serif; color: #111; background: #fff; padding: 48px; max-width: 800px; margin: auto; line-height: 1.7; }
        .header { display:flex; align-items:center; justify-content:space-between; border-bottom: 4px solid #58FF88; padding-bottom: 20px; margin-bottom: 32px; }
        .brand { font-size: 30px; font-weight: 900; letter-spacing: 3px; }
        .brand sup { font-size: 13px; }
        .meta { text-align:right; font-size: 12px; color: #888; line-height: 1.6; }
        .tag { display:inline-block; background:#58FF88; color:#000; font-size:10px; font-weight:700; letter-spacing:2px; padding:3px 10px; border-radius:3px; text-transform:uppercase; margin-bottom:24px; }
        h1 { font-size: 22px; font-weight: 900; margin-bottom: 6px; }
        .subtitle { font-size: 14px; color: #666; margin-bottom: 40px; }
        .section { margin-bottom: 28px; }
        .section-label { font-size: 10px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; color: #58FF88; background: #000; padding: 4px 10px; display:inline-block; border-radius:3px; margin-bottom: 12px; }
        .row { display:flex; gap:16px; margin-bottom: 8px; border-bottom: 1px solid #f0f0f0; padding-bottom:8px; }
        .row-label { font-size:11px; font-weight:700; text-transform:uppercase; color:#888; letter-spacing:1px; min-width:180px; padding-top:2px; }
        .row-val { font-size:14px; flex:1; }
        .report-body { font-size: 14px; line-height: 1.9; }
        .report-section { margin-bottom: 32px; padding-bottom: 24px; border-bottom: 2px solid #e0e0e0; }
        .report-section:last-child { border-bottom: none; }
        .report-section-title { font-size: 18px; font-weight: 900; color: #000; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 1px; }
        .report-section-body { font-size: 14px; color: #222; line-height: 1.9; white-space: pre-wrap; }
        .report-body p { margin-bottom: 12px; }
        .report-body strong { color: #000; }
        .footer { margin-top: 48px; padding-top: 16px; border-top: 1px solid #ddd; font-size: 11px; color: #aaa; text-align:center; }
        @media print { body { padding: 24px; } }
      </style>
    </head><body>
      <div class="header">
        <div class="brand">ERRE ZETA<sup>®</sup></div>
        <div class="meta">Informe interno — uso exclusivo del equipo<br>${fecha}</div>
      </div>
      <div class="tag">Informe de prospecto</div>
      <h1>${data.nombre_negocio || "Sin nombre"}</h1>
      <div class="subtitle">${data.nombre_contacto ? `Contacto: ${data.nombre_contacto}` : ""} ${data.email ? `· ${data.email}` : ""}</div>

      <div class="section">
        <div class="section-label">Respuestas del cuestionario</div>
        ${rows.map(r=>`<div class="row"><div class="row-label">${r.label}</div><div class="row-val">${r.val}</div></div>`).join("")}
      </div>

      <div class="section">
        <div class="section-label">Análisis estratégico IA</div>
        <div class="report-body">${
          (reportText || report)
            .split(/\n(?=\d+\.\s+[A-ZÁÉÍÓÚ])/)
            .map(section => {
              const lines = section.trim().split('\n');
              const title = lines[0].replace(/^\d+\.\s+/, '').trim();
              const body = lines.slice(1).join('\n').trim();
              return `<div class="report-section">
                <div class="report-section-title">${title}</div>
                <div class="report-section-body">${body}</div>
              </div>`;
            }).join('')
        }</div>
      </div>

      <div class="footer">Documento confidencial · ERRE ZETA® · Generado automáticamente</div>
    </body></html>`);
    win.document.close();
    setTimeout(() => win.print(), 600);
  };

  // ── VISTA DEL CLIENTE (pantalla de gracias limpia) ──
  return (
    <div style={s.wrap}>
      <div style={s.header}><ErreZetaLogo width={110} /></div>
      <div style={s.main}>

        {/* Pantalla de gracias — lo que ve el cliente */}
        <div style={{textAlign:"center", padding:"20px 0 60px"}}>
          <div style={{width:72,height:72,borderRadius:"50%",background:`${G}18`,border:`2px solid ${G}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,margin:"0 auto 28px"}}>✓</div>
          <h2 style={{fontSize:30,fontWeight:900,color:"#fff",marginBottom:14,lineHeight:1.2}}>
            ¡Gracias, {data.nombre_contacto || data.nombre_negocio || ""}!
          </h2>
          <p style={{fontSize:16,color:MG,lineHeight:1.8,maxWidth:480,margin:"0 auto 40px"}}>
            Recibimos toda tu información. Nuestro equipo la revisará y se pondrá en contacto contigo pronto para dar el siguiente paso.
          </p>
          <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
            {[["📩","Información recibida"],["🔍","Estamos analizando tu caso"],["📞","Te contactaremos pronto"]].map(([icon,txt])=>(
              <div key={txt} style={{background:"#111",border:"1px solid #222",borderRadius:10,padding:"14px 18px",fontSize:13,color:LG,display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18}}>{icon}</span>{txt}
              </div>
            ))}
          </div>
        </div>

        {/* Separador interno */}
        <div style={{borderTop:"1px solid #1a1a1a",paddingTop:32,marginBottom:28}}>
          <div style={{...s.sectionLabel, display:"flex", alignItems:"center", gap:8}}>
            <span style={{background:G,color:BK,padding:"2px 8px",borderRadius:4,fontSize:10}}>USO INTERNO</span>
            Informe estratégico
          </div>
          <p style={{fontSize:13,color:DG,marginTop:6}}>Este informe es generado automáticamente para el equipo de ERRE ZETA.</p>
        </div>

        {/* Estado del proceso */}
        <div style={{background:"#0d0d0d",border:"1px solid #222",borderRadius:12,padding:"24px",marginBottom:32}}>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* Generación IA */}
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div style={{width:36,height:36,borderRadius:"50%",background: status==="done" ? `${G}22` : status==="error" ? "#ff444422" : "#222", border:`2px solid ${status==="done"?G:status==="error"?"#ff4444":"#444"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>
                {status==="done" ? "✓" : status==="error" ? "✗" : "⏳"}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:status==="done"?G:status==="error"?"#ff6666":"#888"}}>
                  {status==="generating" ? "Generando informe con IA..." : status==="done" ? "Informe generado" : "Error al generar informe"}
                </div>
                <div style={{fontSize:12,color:DG,marginTop:2}}>Análisis FODA · Clasificación del prospecto · Recomendaciones estratégicas</div>
              </div>
            </div>
            {/* Envío de correo */}
            {EMAILJS_SERVICE_ID !== "TU_SERVICE_ID" && (
              <div style={{display:"flex",alignItems:"center",gap:14}}>
                <div style={{width:36,height:36,borderRadius:"50%",background: emailStatus==="sent" ? `${G}22` : emailStatus==="error" ? "#ff444422" : "#222", border:`2px solid ${emailStatus==="sent"?G:emailStatus==="error"?"#ff4444":"#444"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>
                  {emailStatus==="sent" ? "✓" : emailStatus==="error" ? "✗" : "📧"}
                </div>
                <div>
                  <div style={{fontSize:14,fontWeight:700,color:emailStatus==="sent"?G:emailStatus==="error"?"#ff6666":"#888"}}>
                    {emailStatus==="pending" ? "Correo en espera..." : emailStatus==="sent" ? `Informe enviado a ${RECIPIENT_EMAIL}` : "Error al enviar correo"}
                  </div>
                  <div style={{fontSize:12,color:DG,marginTop:2}}>El informe completo llega al correo del equipo</div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Aviso configuración EmailJS */}
        {EMAILJS_SERVICE_ID === "TU_SERVICE_ID" && (
          <div style={{background:"#1a0f00",border:"1px solid #ff9900",borderRadius:8,padding:"14px 18px",marginBottom:28,fontSize:13,color:"#ff9900",lineHeight:1.6}}>
            ⚠ <strong>Correo no configurado.</strong> Para activar el envío automático, reemplaza <code>EMAILJS_SERVICE_ID</code>, <code>EMAILJS_TEMPLATE_ID</code>, <code>EMAILJS_PUBLIC_KEY</code> y <code>RECIPIENT_EMAIL</code> al inicio del código.
          </div>
        )}

        {/* Botón PDF — disponible cuando el informe esté listo */}
        {status === "done" && (
          <div style={{marginBottom:40}}>
            <button style={s.btnPrimary} onClick={() => printPDF(report)}>
              ⬇ Exportar informe en PDF
            </button>
          </div>
        )}

        {status === "error" && (
          <button style={{...s.btnGhost, marginBottom:32}} onClick={generateAndSend}>↺ Reintentar generación</button>
        )}

        <div style={{marginTop:20,textAlign:"center"}}>
          <button style={s.btnSecondary} onClick={onRestart}>← Nuevo cuestionario</button>
        </div>
      </div>
    </div>
  );
}